import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from 'src/app/services/seo.service';
import { AgendaModel, EventoModel } from '../../models/agenda.model';
import { AsociacionService } from '../../services/asociacion.service';
@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss'],
})
export class AgendaComponent extends SeoService implements OnInit {
  public eventos: EventoModel[] = [];
  public agenda: AgendaModel[] = [];
  currentYear: number = new Date().getFullYear();
  public loading: boolean = false;

  constructor(
    private _asociacionService: AsociacionService,
    private titleSerive: Title,
    private metaService: Meta
  ) {
    super(titleSerive, metaService);
  }

  ngOnInit(): void {
    this.updateTags('Agenda', 'agenda');

    this.loading = true;
    this.getAgenda();
  }

  getEventosDelMesOrdenados(eventos: EventoModel[]) {
    return eventos.sort((eventoA, eventoB) => {
      const timestampA = new Date(eventoA.fechaInicio).getTime();
      const timestampB = new Date(eventoB.fechaInicio).getTime();
      return timestampA > timestampB ? 1 : 0;
    });
  }

  getAgenda() {
    this._asociacionService.getAgenda().subscribe(
      (response) => {
        this.eventos = response.data;
        this.separetedEventes();
      },
      (error) => {
        console.log('error :>> ', error);
        this.loading = false;
      }
    );
  }

  separetedEventes() {
    // Filtrar por los eventos que estén activos
    this.eventos = this.eventos.filter((e) => e.activo);

    for (let i = 0; i < this.eventos.length; i++) {
      // Extraer mes y anio
      const partesFecha = this.eventos[i].fechaInicio.split('-');
      const dia = +partesFecha[2];
      const mes = +partesFecha[1];
      const anio = +partesFecha[0];

      // Comprobar si this.agenda esta vacia
      if (this.agenda.length === 0) {
        // Si this.agenda esta vacia insertar el mes con el evento
        // * Utilizar mes y anio como id unico
        const newEvento = {
          idMes: +`${mes}${anio}`,
          dia: dia,
          mes: this.setName(mes),
          anio: anio,
          evento: [this.eventos[i]],
        };
        this.agenda.push(newEvento);
      } else {
        // Buscar si ya existe el mes y anio del objeto actual
        const yaExisteIndex = this.agenda.findIndex(
          (a) => a.idMes === +`${mes}${anio}`
        );
        if (yaExisteIndex >= 0) {
          // Si this.agenda no esta vacia y ya existe el mes y anio, simplemente insertar en su arreglo eventos
          this.agenda[yaExisteIndex].evento.push(this.eventos[i]);
        } else {
          // Si this.agenda no esta vacia y no existe el mes y anio, insertar el mes y anio con el evento
          // * Utilizar mes y anio como id unico
          const newEvento = {
            idMes: +`${mes}${anio}`,
            dia: dia,
            mes: this.setName(mes),
            anio: anio,
            evento: [this.eventos[i]],
          };
          this.agenda.push(newEvento);
        }
      }

      // Ordenar por anio
      const sortByYear = (periodo: AgendaModel[]) =>
        periodo.sort((mesA: AgendaModel, mesB: AgendaModel) => {
          if (mesA.anio > mesB.anio) return -1;
          if (mesA.anio < mesB.anio) return 1;
          return 0;
        });

      // Ordenar por mes
      const sortByMonth = (periodo: AgendaModel[]) =>
        periodo.sort((mesA: AgendaModel, mesB: AgendaModel) => {
          if (mesA.idMes < mesB.idMes) return 1;
          return 0;
        });

      const sortByDate = (periodo: AgendaModel[]) => 
        periodo.sort((eventoA: AgendaModel, eventoB: AgendaModel) => {
        return eventoA.dia < eventoB.dia ? 0 : 1;
      });

      this.agenda = sortByMonth(this.agenda);
      this.agenda = sortByYear(this.agenda);
      this.loading = false;
    }
  }

  setName(idMes: number): string {
    if (idMes === 1) {
      return 'Enero';
    } else if (idMes === 2) {
      return 'Febrero';
    } else if (idMes === 3) {
      return 'Marzo';
    } else if (idMes === 4) {
      return 'Abril';
    } else if (idMes === 5) {
      return 'Mayo';
    } else if (idMes === 6) {
      return 'Junio';
    } else if (idMes === 7) {
      return 'Julio';
    } else if (idMes === 8) {
      return 'Agosto';
    } else if (idMes === 9) {
      return 'Septiembre';
    } else if (idMes === 10) {
      return 'Octubre';
    } else if (idMes === 11) {
      return 'Noviembre';
    } else if (idMes === 12) {
      return 'Diciembre';
    }
    return '';
  }
}
